import {
  ChipField,
  DateField,
  List as RaList,
  TextField,
  usePermissions,
  useTranslate,
} from "react-admin";
import { Datagrid, LongTextField, useFieldLabel } from "ra-friendsofbabba";
import React, { Fragment, useCallback, useMemo } from "react";

import Actions from "../component/list/Actions";
import ExportButton from "../component/button/ExportButton";
import Filters from "./Filters";
import PrintButton from "../component/button/PrintButton";
import UserField from "../component/field/UserField";

const PrintButtonWrapper = ({ newResource, ...props }) => {
  return <PrintButton {...props} resource={newResource} />;
};

const List = (props) => {
  const { loaded, permissions } = usePermissions();
  const isAdmin = useMemo(
    () => loaded && permissions(["admin"]),
    [loaded, permissions]
  );
  const additionalProps = isAdmin ? {} : { bulkActionButtons: false };
  const translate = useTranslate();
  const resLabel = useCallback(
    (name) => translate(`resources.${name}.short`, { smart_count: 0 }),
    [translate]
  );
  const epFieldLabel = useFieldLabel({ resource: "executive-projects" });
  const trFieldLabel = useFieldLabel({ resource: "technical-reports" });
  const treFieldLabel = useFieldLabel({ resource: "technical-report-evals" });
  const label = useCallback(
    (resource, label) => (
      <Fragment>
        {resLabel(resource)}
        <br />
        {label}
      </Fragment>
    ),
    [resLabel]
  );

  return (
    <RaList
      {...props}
      {...additionalProps}
      filters={<Filters />}
      actions={
        <Actions canExport={false} canCreate={false}>
          <ExportButton />
        </Actions>
      }
      perPage={25}
      sort={{ field: "ExecutiveProjects.id", order: "DESC" }}
    >
      <Datagrid>
        <TextField
          source="executive_project.project_proposal.code"
          label={epFieldLabel("project_proposal.code")}
        />
        <LongTextField
          source="executive_project.project_proposal.project_idea.university.name"
          label={epFieldLabel("university")}
        />
        <LongTextField
          source="executive_project.project_proposal.project_idea.university_department.name"
          label={epFieldLabel("university_department")}
        />
        <LongTextField
          source="executive_project.project_proposal.name"
          label={epFieldLabel("project_proposal.name")}
        />
        <DateField
          source="sent_transaction.created"
          label={label("technical-reports", trFieldLabel("sent"))}
        />
        <TextField
          source="technical_report_group.name"
          label={label(
            "technical-reports",
            trFieldLabel("technical_report_group.name.short")
          )}
        />
        <UserField
          source="user.name"
          label={label("technical-reports", trFieldLabel("user_id"))}
        />
        <DateField
          source="closing"
          label={label("technical-reports", trFieldLabel("closing"))}
        />
        <ChipField
          source="state"
          color="primary"
          label={label("technical-reports", trFieldLabel("state"))}
        />
        <PrintButtonWrapper
          {...props}
          newResource="technical-reports"
          label="resources.technical-reports.buttons.print"
        />
        <UserField
          source="technical_report_eval.user.name"
          label={label("technical-report-evals", treFieldLabel("user.name"))}
        />
        <DateField
          source="technical_report_eval.expiry"
          label={label("technical-report-evals", treFieldLabel("expiry"))}
        />
        <ChipField
          source="technical_report_eval.state"
          label={label("technical-report-evals", treFieldLabel("state"))}
        />
        <PrintButtonWrapper
          {...props}
          newResource="technical-report-evals"
          sourceId="technical_report_eval.id"
          label="resources.technical-report-evals.buttons.print"
        />
      </Datagrid>
    </RaList>
  );
};
export default List;
